"use client";

import type { FC, ReactNode } from "react";
import * as RadixTooltip from "@radix-ui/react-tooltip";
import { cn } from "@/lib/cn";

type HoverTooltipProps = {
  label: ReactNode;
  side?: RadixTooltip.TooltipContentProps["side"];
  className?: string;
  children: ReactNode;
};

export const HoverTooltip: FC<HoverTooltipProps> = ({ label, side = "top", className, children }) => (
  <RadixTooltip.Provider delayDuration={200}>
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>
        <span className={cn("flex min-w-0 max-w-full", className)}>{children}</span>
      </RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          sideOffset={6}
          collisionPadding={16}
          className="z-50 max-w-320 rounded-regular bg-neutral-black px-12 py-8 text-14 text-neutral-white shadow-lg animate-[fade-in_150ms_ease-out]"
        >
          {label}
          <RadixTooltip.Arrow className="fill-neutral-black" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  </RadixTooltip.Provider>
);
